'use strict';

import angular from 'angular';

export default angular.module('directives.leftnav', [])
  .name;



// WEBPACK FOOTER //
// ./client/components/leftnav/leftnav.module.js